module.exports = __webpack_public_path__ + "img/baphomet.cefbd814.jpg";